import * as React from 'react';

import {Button} from 'shells/button/button';
import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {UpgradeArrowIcon} from 'shells/icon/svg/upgrade-arrow-icon';

import {ShareableListsFeatureGate} from '../../limits/feature-gates/shareable-lists-feature-gate';
import {ShareableReportsFeatureGate} from '../../limits/feature-gates/shareable-reports-feature-gate';

import type {ParentType} from './title-bar-save-controls-container';

import styles from './title-bar-save-controls.module.css';

type Props = {
    parentType: ParentType;
};

export function TitleBarShareButtonUpsell(props: Props) {
    const [isFeatureGateModalOpen, setIsFeatureGateModalOpen] = React.useState(false);
    const parentType = props.parentType;

    return (
        <>
            <Button variant='secondary' size='big' onClick={() => setIsFeatureGateModalOpen(true)}>
                <div className={styles.share}>
                    <span className='mr-4'>Share</span>
                    <UpgradeArrowIcon alignCenter={true} size={16} color={colors.blue} />
                </div>
            </Button>
            {parentType === 'entity-list' && (
                <ShareableListsFeatureGate
                    isOpen={isFeatureGateModalOpen}
                    onClose={() => setIsFeatureGateModalOpen(false)}
                />
            )}
            {parentType === 'reports' && (
                <ShareableReportsFeatureGate
                    isOpen={isFeatureGateModalOpen}
                    onClose={() => setIsFeatureGateModalOpen(false)}
                />
            )}
        </>
    );
}
